'use client';

import Image from 'next/image';
import { ProductStatusText } from '@eliadmin/core/src/components/product/product-status-text';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../../ui/paragraph';

export function ProductDetailAvailability() {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const product = useVariantsStore(state => state.product);

  const availability = selectedVariant?.availability ?? product?.availability;

  if (product.status === 'ended' || product.status === 'arrival') {
    return <ProductStatusText status={product.status} />;
  }

  // `variants` is `[]` for products without variants, and `[]` is truthy — so the quantity was
  // read from the (undefined) selected variant and the label rendered as just "ks skladem".
  const desiredObject = product.variants?.length ? selectedVariant : product;

  const isAvailable = availability?.id === 1;

  if (isAvailable)
    return (
      <div className={cn('flex items-center justify-start gap-2')}>
        <Image
          src="/images/icons/storefront.svg"
          alt=""
          aria-hidden
          width={20}
          height={20}
          className="shrink-0 object-contain"
        />
        <Paragraph className="font-bold lowercase text-[#008000]">
          {/* Stock is not synced for every product — the API then reports 0 while availability
              still says "Skladom", which rendered as a contradictory "0 ks skladom". */}
          {desiredObject?.quantity != null && desiredObject.quantity > 0 && (
            <>
              {desiredObject.quantity}&nbsp;{product?.unit}&nbsp;
            </>
          )}
          {availability?.name}
        </Paragraph>
      </div>
    );
}
